/* eslint-disable */
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CheckIcon from '@material-ui/icons/Check';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
    width: 'auto',
    minWidth: 300,
  },
  stepWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 11,
    transition: 'all 0.3s ease',
    border: '2px solid',
  },
  stepInactive: {
    backgroundColor: '#f8f9fa',
    borderColor: '#e2e8f0',
    color: '#a0aec0',
  },
  stepActive: {
    backgroundColor: '#5B65DC',
    borderColor: '#5B65DC',
    color: 'white',
    boxShadow: '0 0 0 2px rgba(0, 168, 255, 0.2)',
  },
  stepCompleted: {
    backgroundColor: '#41C377',
    borderColor: '#41C377',
    color: 'white',
  },
  stepLabel: {
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    transition: 'color 0.3s ease',
    whiteSpace: 'nowrap',
  },
  stepLabelInactive: {
    color: '#a0aec0',
  },
  stepLabelActive: {
    color: '#5B65DC',
  },
  stepLabelCompleted: {
    color: '#41C377',
  },
  connector: {
    width: 40,
    height: 1,
    transition: 'background-color 0.3s ease',
    marginTop: -10,
  },
  connectorInactive: {
    backgroundColor: '#e2e8f0',
  },
  connectorActive: {
    backgroundColor: '#5B65DC',
  },
  connectorCompleted: {
    backgroundColor: '#41C377',
  },
}));

const Breadcrumbs = ({ activeStep, steps }) => {
  const classes = useStyles();

  const stepsData = [
    { label: 'SELECT', step: 0 },
    { label: 'CHOOSE', step: steps[0] },
    { label: 'CONFIRM', step: steps[1] },
  ];

  const getStepStatus = (stepIndex, stepValue) => {
    if (stepIndex === 0) {
      return activeStep === 0 ? 'active' : activeStep > 0 ? 'completed' : 'inactive';
    }
    if (stepIndex === 1) {
      return activeStep > 0 && activeStep <= stepValue ? 'active' : activeStep > stepValue ? 'completed' : 'inactive';
    }
    if (stepIndex === 2) {
      return activeStep >= stepValue ? 'active' : 'inactive';
    }
    return 'inactive';
  };

  const getConnectorStatus = (stepIndex) => {
    if (stepIndex === 0) {
      return activeStep > 0 ? 'completed' : 'inactive';
    }
    if (stepIndex === 1) {
      return activeStep > steps[0] ? 'completed' : activeStep > 0 ? 'active' : 'inactive';
    }
    return 'inactive';
  };

  return (
    <div className={classes.stepperContainer}>
      {stepsData.map((stepData, index) => {
        const status = getStepStatus(index, stepData.step);
        const isLast = index === stepsData.length - 1;

        return (
          <Fragment key={stepData.label}>
            <div className={classes.stepWrapper}>
              <div
                className={cx(classes.stepCircle, {
                  [classes.stepInactive]: status === 'inactive',
                  [classes.stepActive]: status === 'active',
                  [classes.stepCompleted]: status === 'completed',
                })}
              >
                {status === 'completed' ? (
                  <CheckIcon style={{ fontSize: 14 }} />
                ) : (
                  index + 1
                )}
              </div>
              <div
                className={cx(classes.stepLabel, {
                  [classes.stepLabelInactive]: status === 'inactive',
                  [classes.stepLabelActive]: status === 'active',
                  [classes.stepLabelCompleted]: status === 'completed',
                })}
              >
                {stepData.label}
              </div>
            </div>

            {!isLast && (
              <div
                className={cx(classes.connector, {
                  [classes.connectorInactive]: getConnectorStatus(index) === 'inactive',
                  [classes.connectorActive]: getConnectorStatus(index) === 'active',
                  [classes.connectorCompleted]: getConnectorStatus(index) === 'completed',
                })}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

Breadcrumbs.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.number).isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default Breadcrumbs;
